

// React Router
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";

// Components
import NavbarMain from "./components/Navigation-Bar";
import Footer from "./components/Footer";
import ContactWidget from "./components/ContactWidget";

// Pages
import HomePage from "./Page/Home-page";
import Main from "./Page/Home-page/LandingPage";
import Career from "./Page/Career";
import NotFoundPage from "./Page/NotFoundPage";
import OurServicesSection from "./Page/Home-page/OurServicesSection";
import Certificate from "./Page/Home-page/Certificate";
import History from "./Page/History";
import Form from "./Page/Form";
import About from "./Page/Home-page/About";

// Services Pages
import BusinessLaw from "./Page/Services-page/Law/BusinessLaw";
import TaxLaw from "./Page/Services-page/Law/TaxLaw";
import OtherLaw from "./Page/Services-page/Law/OtherLaw";
import Litigation from "./Page/Services-page/Law/Litigation";
import Testament from "./Page/Services-page/Law/Testament";
import TransferPricing from "./Page/Services-page/Law/TransferPricing";
import CivilLitigation from "./Page/Services-page/Law/CivilLitigation";
import DivorceAndAssetManagement from "./Page/Services-page/Law/Divorce";
import Payroll from "./Page/Services-page/Accounting-and-payroll/Payroll";
import Accounting from "./Page/Services-page/Accounting-and-payroll/Accounting";
import StatementAudit from "./Page/Services-page/Check-account/StatementAudit";
import StatementReview from "./Page/Services-page/Check-account/StatementReview";
import SpecialAudit from "./Page/Services-page/Check-account/SpecialAudit";
import AccountingAdvisory from "./Page/Services-page/Check-account/AccountingAdvisory";
import InternalAudit from "./Page/Services-page/Internal-audit/InternalAudit"; 
import IPO from "./Page/Services-page/Internal-audit/IPO";
import CAC from "./Page/Services-page/Internal-audit/CAC";
import QAR from "./Page/Services-page/Internal-audit/QAR";
import ITAudit from "./Page/Services-page/Internal-audit/ITAudit";
import SystemDevelopment from "./Page/Services-page/Internal-audit/SystemDevelopment";
import BusinessDevelopment from "./Page/Services-page/Internal-audit/BusinessDevelopment";
import SpecialInvestigation from "./Page/Services-page/Internal-audit/SpecialInvestigation";
import ESGReporting from "./Page/Services-page/Internal-audit/ESGReporting";
import DueDiligence from "./Page/Services-page/Check-account/DueDiligence";
import CarbonFootprint from "./Page/Services-page/Internal-audit/CarbonFootprint";
import InHouse from "./Page/Services-page/Internal-audit/InHouse";
import AIGovernance from "./Page/Services-page/Internal-audit/AIGovernance";
import AIGRA from "./Page/Services-page/Internal-audit/AIGRA";
import WebService from "./Page/Services-page/Website-and-IT-development/WebService";
import WebHosting from "./Page/Services-page/Website-and-IT-development/WebHosting";
import WebMaintenance from "./Page/Services-page/Website-and-IT-development/WebMaintenance";


// Career Pages
import ITSupport from "./Page/Career-page/IT-Support";
import DataEngineering from "./Page/Career-page/Data-Engineering";
import SoftwareDeveloper from "./Page/Career-page/Software-Developer";
import Accountant from "./Page/Career-page/Accountant";


// Router Configuration
const router = createBrowserRouter([
  // Home
  { path: "/", element: <Navigate to="/home" replace /> },
  { path: "/home", element: <HomePage /> },

  // Services
  { path: "/services/business-law", element: <BusinessLaw /> },
  { path: "/services/tax-law", element: <TaxLaw /> },
  { path: "/services/other-law", element: <OtherLaw /> },
  { path: "/services/litigation", element: <Litigation /> },
  { path: "/services/transfer-pricing", element: <TransferPricing /> },
  { path: "/services/testament", element: <Testament /> },
  { path: "/services/civil-litigation", element: <CivilLitigation /> },
  { path: "/services/divorce", element: <DivorceAndAssetManagement /> },
  { path: "/services/payroll", element: <Payroll /> },
  { path: "/services/accounting", element: <Accounting /> },
  { path: "/services/statement-audit", element: <StatementAudit /> },
  { path: "/services/statement-review", element: <StatementReview /> },
  { path: "/services/special-audit", element: <SpecialAudit /> },
  { path: "/services/accounting-advisory", element: <AccountingAdvisory /> },
  { path: "/services/internal-audit", element: <InternalAudit /> },
  { path: "/services/ipo", element: <IPO /> },
  { path: "/services/cac", element: <CAC /> },
  { path: "/services/qar", element: <QAR /> },
  { path: "/services/it-audit", element: <ITAudit /> },
  { path: "/services/system-development", element: <SystemDevelopment /> },
  { path: "/services/business-development", element: <BusinessDevelopment /> },
  { path: "/services/special-investigation", element: <SpecialInvestigation /> },
  { path: "/services/esg-reporting", element: <ESGReporting /> },
  { path: "/services/due-diligence", element: <DueDiligence /> },
  { path: "/services/carbon-footprint", element: <CarbonFootprint /> },
  { path: "/services/in-house", element: <InHouse /> },
  { path: "/services/ai-governance", element: <AIGovernance /> },
  { path: "/services/ai-gra", element: <AIGRA /> },
  { path: "/services/web-service", element: <WebService /> },
  { path: "/services/web-hosting", element: <WebHosting /> },
  { path: "/services/web-maintenance", element: <WebMaintenance /> },


  // Career Pages
  { path: "/careers/it-support", element: <ITSupport /> },
  { path: "/careers/data-engineering", element: <DataEngineering /> },
  { path: "/careers/software-developer", element: <SoftwareDeveloper /> },
  { path: "/careers/accountant", element: <Accountant /> },

  // Other Pages
  { path: "/careers", element: <Career /> },
  { path: "/form", element: <Form /> },
  { path: "/history", element: <History /> },
  { path: "/services", element: <OurServicesSection /> },
  { path: "/main", element: <Main /> },
  { path: "/certificate", element: <Certificate /> },
  { path: "/*", element: <NotFoundPage /> },
  { path: "/about", element: <About /> },
]);


// Main App Component
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <NavbarMain />
        <RouterProvider router={router} />
      </header>
      <Footer />
      <ContactWidget />
    </div>
  );
}

export default App;
